const middleware = {}

middleware['check-login'] = require('../../../middleware/check-login.js')
middleware['check-login'] = middleware['check-login'].default || middleware['check-login']

middleware['cookie-parser'] = require('../../../middleware/cookie-parser.js')
middleware['cookie-parser'] = middleware['cookie-parser'].default || middleware['cookie-parser']

middleware['cookie-setup'] = require('../../../middleware/cookie-setup.js')
middleware['cookie-setup'] = middleware['cookie-setup'].default || middleware['cookie-setup']

middleware['home-validate'] = require('../../../middleware/home-validate.js')
middleware['home-validate'] = middleware['home-validate'].default || middleware['home-validate']

middleware['redirect'] = require('../../../middleware/redirect.js')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['ua-parser'] = require('../../../middleware/ua-parser.js')
middleware['ua-parser'] = middleware['ua-parser'].default || middleware['ua-parser']

export default middleware
